import { HelpCircle } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

/** "?" que explica o que conta em cada sinal de dia trabalhado (App / Agenda / Cadastro). */
export function AjudaSinais() {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button type="button" className="inline-flex text-muted-foreground hover:text-foreground" aria-label="O que é App, Agenda e Cadastro">
            <HelpCircle className="h-3.5 w-3.5" />
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs space-y-1.5 text-xs">
          <p><strong>App</strong>: dia em que a pessoa entrou no Kora (fez login).</p>
          <p><strong>Agenda</strong>: dia em que a pessoa tinha um evento no calendário, criado por ela ou em que ela participa (eventos cancelados e convites recusados não contam).</p>
          <p><strong>Ação</strong>: dia em que a pessoa criou ou editou algo em qualquer módulo (OKRs, Projetos, Calendário, Organograma, Fluxogramas, Treinamentos, Formulários etc.).</p>
          <p><strong>Todos</strong>: dia com qualquer um dos três.</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
